import React, { Children } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { useWindowSize } from 'modules/core';

export default function SignUpFormGrid({ children }) {
  const items = Children.toArray(children);
  const { mobileWidth } = useWindowSize();

  return (
    <Grid container spacing={0}>
      <Grid container spacing={mobileWidth ? 0 : 3}>
        <Grid
          size={{
            sm: 6,
            xs: 12,
          }}
        >
          {items[0]}
        </Grid>
        <Grid
          size={{
            sm: 6,
            xs: 12,
          }}
        >
          {items[1]}
        </Grid>
      </Grid>
      <Grid size={12}>{items[2]}</Grid>
      <Grid size={12}>{items[3]}</Grid>
      <Grid size={12}>{items[4]}</Grid>
      <Grid size={12}>{items[5]}</Grid>
    </Grid>
  );
}

SignUpFormGrid.propTypes = {
  children: PropTypes.node,
};
